import {
  Component,
  OnInit,

  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import {
  UploadXHRArgs,
  UploadChangeParam,
  UploadFile,
  InputBoolean,
  InputNumber,
  NzMessageService,
  NzNotificationService,
} from 'ng-zorro-antd';
import {of, timer, Observable, Observer, from} from 'rxjs';
import {UploadService} from '../../services';
import {
  map,
  switchMap,
  debounceTime,
  catchError,
} from 'rxjs/operators';

import {FormControl} from '@angular/forms';
import {CustomValidators} from 'ng2-validation';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from 'src/environments/environment';
import {AuthService} from 'src/app/auth';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'con-uploader',
  templateUrl: './uploader.component.html',
  styleUrls: ['./uploader.component.scss'],
})
export class UploaderComponent implements OnInit {
  // baseUrl = environment.apiBaseUrl;
  // baseUrl = "https://apis.icheck.vn/upload/image/v1/url";
  baseUrl = 'https://upload.icheck.com.vn/upload/url';
  @Input() @InputNumber() maxSize = 0;
  @Input() fileType: string;
  @Input() fileExt: string;
  @Input() @InputBoolean() multiple = false;
  // tslint:disable-next-line:no-output-native
  @Output() change = new EventEmitter<UploadChangeParam>();
  @Output() done = new EventEmitter<void>();

  @Input() sizes: any[] = [];
  @Output() returnSize = new EventEmitter<any>();
  size: string;

  showUploadButton = true;
  uploadError: string;
  remoteUrlCtrl: FormControl = new FormControl(null, CustomValidators.url);
  errorUrl = false;

  constructor(
    private notification: NzNotificationService,
    private upload: UploadService,
    private message: NzMessageService,
    private http: HttpClient,
    private authService: AuthService
  ) {
  }

  token = '';
  checkUrl = false;

  loadFileAsText() {
    const fileToLoad = document.getElementById(
      'fileToLoad'
    ) as HTMLInputElement;
    // tslint:disable-next-line:no-unused-expression
    fileToLoad.files[0];
    const fileReader = new FileReader();
    fileReader.onload = () => {
      const textFromFileLoaded = fileReader.result;
      const inputElement = document.getElementById(
        'inputTextToSave'
      ) as HTMLInputElement;
      inputElement.value = textFromFileLoaded.toString();
      this.remoteUrlCtrl.setValue(textFromFileLoaded.toString());
    };
    fileReader.readAsText(fileToLoad.files[0], 'UTF-8');
  }

  ngOnInit() {
    this.checkUrl = window.location.href.includes('products');
    if (window.location.href.includes('distributors')) {
      this.checkUrl = false;
    }

    this.notification.config({
      nzPlacement: 'bottomRight',
    });
    const user = this.authService.currentUserValue;
    this.token = user.token;
    this.remoteUrlCtrl.statusChanges
      .pipe(
        debounceTime(300),
        switchMap((status) => {
          console.log('status link:', status);
          if (status === 'INVALID' || !this.remoteUrlCtrl.value) {
            return of(null);
          }
          this.errorUrl = false;
          const url = this.remoteUrlCtrl.value;

          this.remoteUrlCtrl.disable({emitEvent: false});

          const httpOptions = {
            headers: new HttpHeaders({
              Authorization: 'Bearer ' + this.token,
            }),
          };

          const body = {
            url
          };

          return this.http.post(`${this.baseUrl}`, body, httpOptions).pipe(
            catchError((err) => {
              this.remoteUrlCtrl.enable({emitEvent: false});

              return of(null);
            })
          );
        })
      )
      .subscribe(
        (res) => {
          console.log('link pdf: ', res);

          if (res) {
            const data = res;
            const url = {
              id: data.data && data.data.url ? data.data.url : null,
              url: data.data && data.data.url ? data.data.url : null,
            };
            const file = {
              uid: data.data && data.data.url ? data.data.url : null,
              name: data.data && data.data.fileName ? data.data.fileName : null,
              size: 0,
              type: data.type || null,
              response: url,
            };
            this.change.emit({
              file,
              fileList: [file],
              type: 'success',
            });
            this.done.emit();
          } else {
            this.errorUrl = true;
          }
        },
        (error) => {
          this.errorUrl = true;
        }
      );
  }

  beforeUpload = (file: UploadFile) => {
    const promise = new Promise<UploadFile>((resolve, reject) => {
      if (!this.isImage(file.type)) {
        resolve(file);
      }

      const img = new Image();
      img.src = window.URL.createObjectURL(file);
      img.onload = () => {
        const width = img.naturalWidth;
        const height = img.naturalHeight;
        window.URL.revokeObjectURL(img.src);
        file.dimensions = {
          width,
          height,
        };
        resolve(file);
      };
    });

    // tslint:disable-next-line:no-shadowed-variable
    return from(promise).pipe(
      map((file) => {
        console.log(file, this.fileType, this.fileExt);

        if (this.fileType) {
          const type = file.type;
          if (!type || this.fileType.indexOf(type) < 0) {
            this.notification.create(
              'error',
              'Có lỗi xảy ra !!!',
              'Định dạng file không được hỗ trợ'
            );
            return false;
          }
        }

        if (this.fileExt) {
          const ext = file.name.split('.').pop().toLowerCase();
          const validUrl = ['mp4', 'mov', 'avi', 'flv', 'pdf', 'exel',
            'zip', 'csv', 'xlsx', 'docx', 'app', 'txt', 'db', 'mp3', 'log', 'json', 'css', 'js'];
          if ((!ext || this.fileExt.toLowerCase().indexOf(ext) < 0) && this.fileExt.toLowerCase() === 'mp4') {
            this.notification.create(
              'error',
              'Có lỗi xảy ra !!!',
              'Không hỗ trợ video khác định dạng mp4'
            );
            return false;
          }
          if ((!ext || this.fileExt.toLowerCase().indexOf(ext) < 0) && (validUrl.indexOf(ext) >= 0)) {
            this.notification.create(
              'error',
              'Có lỗi xảy ra !!!',
              'Chỉ hỗ trợ định dạng ảnh'
            );
            return false;
          }
        }

        if (file.size) {
          const ext = file.name.split('.').pop().toLowerCase();
          if (
            file.type.indexOf('video') === -1 &&
            file.type.indexOf('mp4') === -1 &&
            file.type.indexOf('quicktime') === -1 &&
            file.type.indexOf('x-msvideo') === -1
          ) {
            if (ext === 'pdf') {
              if (file.size > 20971520) {
                this.notification.create(
                  'error',
                  'Có lỗi xảy ra !!!',
                  'Dung lượng PDF tối đa 20 MB'
                );
                return false;
              }
            } else {
              if (file.size > 5242880) {
                this.notification.create(
                  'error',
                  'Có lỗi xảy ra !!!',
                  'Dung lượng ảnh tối đa 5MB'
                );
                return false;
              }
            }
          }
        }

        if (file.size > 5500 * 19066) {
          this.notification.create(
            'error',
            'Có lỗi xảy ra !!!',
            'Dung lượng video tối đa 100 MB'
          );
          return false;
        }

        if (this.sizes.length) {
          // tslint:disable-next-line:triple-equals
          if (
            !(
              file.dimensions.width == this.sizes[0].width &&
              file.dimensions.height == this.sizes[0].height
            )
          ) {
            this.notification.create(
              'error',
              'Có lỗi xảy ra !!!',
              `Kích cỡ hình ảnh không phù hợp ( ${this.sizes[0].width} x ${this.sizes[0].height} )`
            );
            return false;
          }
        }
        return true;
      })
    );
  }

  tusUpload = (item: UploadXHRArgs | any) => {
    const a = [];
    if (item.file) {
      a.push(item.file);
      // tslint:disable-next-line:new-parens
      const reader = new FileReader();
      const formData = new FormData();
      // @ts-ignore
      formData.append(
        'content',
        item.file,
        item.file.name.split(' ').join('').split(',').join('')
      );

      reader.onload = (e) => {
        const fileData = (e.target as any).result;
        const type = item.file.type.indexOf('image');
        const vidData = new FormData();
        vidData.append('my_field', 'file');
        vidData.append('my_file', item.file);
        if (
          type === -1 &&
          (item.file.type.indexOf('video') === -1 ||
            item.file.type.indexOf('mp4') === -1)
        ) {
          return this.upload.uploadPdf(formData).subscribe((res) => {
              console.log(res);
              return item.onSuccess!(
                {
                  id: res.data.fileId,
                  url: res.data.url,
                },
                item.file!,
                null
              );
            },
            (err) => {
              this.notification.create(
                'error',
                'Thất bại !!!',
                `Có lỗi xảy ra.`
              );
            }
          );
        }

        if (item.file.type.indexOf('video') > -1 || item.file.type.indexOf('mp4') > -1) {

          return this.upload.uploadVideo(vidData).subscribe(
            (res) => {
              console.log(res);
              return item.onSuccess!(
                {
                  id: res.data.fileId,
                  url: res.data.url,
                },
                item.file!,
                null
              );
            },

            (err) => {
              this.notification.create(
                'error',
                'Thất bại !!!',
                `Có lỗi xảy ra.`
              );
            }
          );
        }

        return this.upload.createFlash(vidData).subscribe(
          (res) =>
            // tslint:disable-next-line:no-non-null-assertion
            item.onSuccess!(
              {
                id: res.data.fileId,
                url: res.data.url,
              },
              item.file!,
              null
            ),
          (err) => {
            this.notification.create('error', 'Thất bại !!!', `Có lỗi xảy ra.`);
          }
        );
      };
      reader.readAsArrayBuffer(a[0]);
    }
  }

  onChange($event: UploadChangeParam) {
    console.log('$event', $event)
    if ($event.fileList.filter((file) => file.status !== 'done').length > 0) {
      this.showUploadButton = false;
    } else {
      this.showUploadButton = true;
      this.done.emit();
    }

    this.change.emit($event);
  }

  protected isImage(type: string) {
    return type && type.split('/')[0] === 'image';
  }
}
